import { getUserInfo } from "@/api/auth";
import { authQueryKeys } from "@/shared/queryKey";
import { ApiError, CustomQueryOptions } from "@/types/api";
import { PromiseResolvedReturnType } from "@/types/utils";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

type QueryFnData = PromiseResolvedReturnType<typeof getUserInfo>;

export const useMe = <QueryData = QueryFnData>(
  queryOptions?: CustomQueryOptions<QueryFnData, AxiosError<ApiError>, QueryData>
) => {
  return useQuery({
    queryKey: [...authQueryKeys.user()],
    queryFn: getUserInfo,
    ...queryOptions
  });
};
